module.exports = __webpack_public_path__ + "media/images/icons/country_flags/dg-6f63b8483ecc9d2a0eaba9d57693c421.svg";